import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './animate.min.css';
import './index.scss';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));

if (module.hot) {
	module.hot.accept();
  }
  


// WEBPACK FOOTER //
// ./src/index.js